<template>
  <div class="stamp">
    <div class="h_title">事务管理</div>
    <div class="h_body">
      <div class="hb_head">
        <sw-button
          :disabled="!ttcTable.data.length"
          icon="su-icon-delete"
          type="danger"
          @click="handleTTCDelete"
        >删除事务</sw-button>
        <sw-search
          :placeholder="'关键字（即流水号，事务名称，发起人名称，事务来源）'"
          style="width:400px"
          @search="handleTTCSearch"
        />
      </div>
      <div class="hb_main">
        <sw-table
          v-loading="ttcTable.loading"
          :table-name="'ttc-table'"
          :table-data="ttcTable.data"
          :table-title="ttcTable.title"
          :total-count="ttcTable.count"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="ttcTable.pageSize"
          :empty-text="'没有签章数据'"
          :has-operation="false"
          :table-operation="ttcTable.operation"
          pagination
          @operation-handle="handleOperation"
          @change-page="changePage"
          @size-change="changeSize"
          @selection-change="handleSelectionChange"
        >
          <template
            slot="customcolumn"
            slot-scope="scope"
          >
            <span
              v-if="scope.item.prop=='task_name'"
              :title="'点击查看当前节点办理人信息'"
              class="swTableCell task_name"
              @click="openAssigneeDialog(scope.row)"
            >{{ scope.row[scope.item.prop]?scope.row[scope.item.prop]:'-' }}</span>
            <span
              v-else
              :title="scope.row[scope.item.prop]?scope.row[scope.item.prop]:'-'"
              class="swTableCell"
            >{{ scope.row[scope.item.prop]?scope.row[scope.item.prop]:'-' }}</span>
          </template>
        </sw-table>
      </div>
    </div>
    <sw-dialog
      :visible.sync="assignee.visible"
      center
      append-to-body
      title="当前节点办理人信息"
      destroy-on-close
    >
      <Assignee :taskid="assignee.task_id" />
    </sw-dialog>
  </div>
</template>

<script>
import service from '@/utils/service'
import { parseTime } from '@/utils/index.js'
import Assignee from './assignee.vue'
export default {
  name: 'TTC',
  components: {
    Assignee
  },
  data () {
    return {
      ttcTable: {
        keyword: '',
        pageNum: 1,
        pageSize: 10,
        loading: false,
        count: 0,
        data: [],
        title: [
          { prop: 'serial_number', label: '流水号', sortable: true },
          { prop: 'user_name', label: '发起人姓名', sortable: true },
          { prop: 'organization', label: '发起人部门', sortable: true },
          { prop: 'trans_resource', label: '事务来源', sortable: true },
          { prop: 'trans_name', label: '事务名称', sortable: true },
          { prop: 'task_name', label: '当前节点', sortable: true },
          { prop: 'create_time', label: '发起时间', sortable: true },
          { prop: 'spend_time', label: '已耗时', sortable: true },
          { prop: 'node_time', label: '当前节点已耗时', sortable: true }
        ],
        operation: [
          { name: '详情', icon: 'su-icon-details', operation: 'detail' },
          { name: '授权', icon: 'su-icon-people', operation: 'auth' },
          { name: '删除', icon: 'su-icon-delete', operation: 'delete' }
        ],
        selectedData: []
      },
      assignee: {
        visible: false,
        task_id: ''
      }
    }
  },
  created () {
    this.getTTCList()
  },
  mounted () {
  },
  methods: {
    openAssigneeDialog (row) {
      if (!row.task_id) {
        this.$swMessage({
          message: `该实例已办理或终止，无当前节点办理人信息`,
          type: 'info'
        })
        return
      }
      this.assignee.visible = true
      this.assignee.task_id = row.task_id
    },
    handleSelectionChange (val) {
      this.ttcTable.selectedData = val
    },
    handleTTCSearch (val) {
      this.ttcTable.keyword = val || ''
      this.getTTCList()
    },
    getTTCList () {
      const params = {
        page: this.ttcTable.pageNum,
        limit: this.ttcTable.pageSize,
        keyWords: ''
      }
      if (this.ttcTable.keyword) {
        params['keyWords'] = this.ttcTable.keyword
      }
      this.ttcTable.loading = true
      service
        .get('/ttcApi/v1/manage/queryAllTodo', { params })
        .then(res => {
          this.ttcTable.data = res.data.map(v => {
            v.createTime = parseTime(v.createTime)
            if (!v.user_name) {
              v.user_name = '(游客)'
            }
            if (!v.organization) {
              v.organization = '(暂无)'
            }
            return v
          })
          this.ttcTable.count = res.count
        }).finally(() => {
          this.ttcTable.loading = false
        })
    },
    handleOperation (id, operation) {
      switch (operation) {
        case 'delete':
          this.handleTTCDelete(id)
          break
        default:
        // this.handleStampDetail(id)
      }
    },
    handleTTCDelete () {
      const idArr = this.ttcTable.selectedData.map(item => {
        return item.id
      })
      if (!idArr.length) {
        this.$swMessage.warning('请先选择需要删除的事务')
        return
      }
      this.$swConfirm('确认删除？删除后不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const data = {
            idList: idArr.join()
          }
          return service.post('/ttcApi/v1/manage/deleteTodo', data)
        })
        .then(res => {
          this.$swMessage.success('删除成功')
          this.ttcTable.pageNum = 1
          this.getTTCList()
        })
    },
    getRow (data, key, value) {
      let row
      data.forEach(v => {
        if (v[key] === value) {
          row = v
        }
      })
      return row
    },
    changePage (page) {
      this.ttcTable.pageNum = page
      this.getTTCList()
    },
    changeSize (size) {
      this.ttcTable.pageSize = size
      this.getTTCList()
    }
  }
}
</script>
<style lang="scss">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 70px;
  line-height: 70px !important;
  text-align: center;
}
</style>
<style lang="scss" scoped>
.task_name {
  color: rgba(51, 148, 225, 1);
  cursor: pointer;
  font-weight: bold;
}
.stamp {
  padding: 10px 20px;
  color: #445969;
  background-color: rgb(240, 245, 250);
  .h_date,
  .h_input {
    width: 140px;
  }
}
.authTableDialog_head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.h_title {
  padding-left: 4px;
  border-left: 3px solid #3394e1;
  font-size: 12px;
}
.h_body {
  margin-top: 10px;
  padding: 10px 15px;
  box-shadow: 0px 2px 10px 0px rgba(39, 56, 70, 0.1);
  background: #fff;
  height: 80vh;
}
.hb_head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.hb_main {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #ccc;
}
.h_select {
  width: 300px;
}

.hbm_left {
  width: 320px;
  padding-right: 15px;
}
.hbm_right {
  flex: 1;
  overflow-x: auto;
}
.hml_item_wrapper {
  max-height: 50vh;
  overflow-y: auto;
  width: 305px;
}
.hbml_item {
  margin-bottom: 10px;
}
.separator {
  font-size: 12px;
  width: 20px;
  text-align: center;
}
.needMore {
  padding: 0 20px;
  font-size: 13px;
  color: #ccc;
  cursor: pointer;
}
</style>
